// extracted by mini-css-extract-plugin
export default {"container":"ChynS","title":"sbBW7","description":"XgKbI","skeleton-progress":"OW7CU"};